// extracted by mini-css-extract-plugin
export default {"container":"use-cases-module--container--573ac","wrapper":"use-cases-module--wrapper--1d7d6"};